import { Box, Button, Chip, Grid, Skeleton, Typography } from "@mui/material";

const ExtraInfoSkeleton = ({ isMobile }) => {
  const chipWidths = [70, 95, 80, 110, 85, 100];

  return (
    <Box className='workshop-extra-info'>
      {/* Description */}
      <Box className='workshop-extra-info-description'>
        <Skeleton variant='text' width={140} height={28} />

        <Skeleton variant='text' width='100%' />
        <Skeleton variant='text' width='95%' />
        <Skeleton variant='text' width='90%' />
        <Skeleton variant='text' width='75%' />
      </Box>

      {/* Services */}
      <Box className='workshop-extra-info-services' sx={{ marginTop: 24 }}>
        <Skeleton variant='text' width={100} height={28} />

        <Grid container spacing={1} sx={{ mt: 1 }}>
          {chipWidths.map((width, index) => (
            <Grid item key={index}>
              <Skeleton variant='rounded' width={width} height={32} sx={{ borderRadius: 16 }} />
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Brands */}
      <Box className='workshop-extra-info-brands' sx={{ marginTop: 24 }}>
        {["Exclusive Brands", "Specialized Brands", "Represented Brands"].map((_, index) => (
          <Box key={index} sx={{ marginBottom: 16 }}>
            <Skeleton variant='text' width={170} height={28} />
            <Skeleton variant='text' width='95%' />
            <Skeleton variant='text' width='70%' />
          </Box>
        ))}
      </Box>

      {isMobile && (
        <Button
          disabled
          sx={{
            mt: 2,
            textTransform: "none",
            color: "text.secondary",
          }}
        >
          <Skeleton variant='text' width={140} />
        </Button>
      )}

      {/* Contact Info & Opening Hours */}
      <Grid container spacing={3} className='workshop-extra-info-opening-and-contact' sx={{ mt: 1 }}>
        <Grid item xs={12} sm={6}>
          <Skeleton variant='text' width={120} height={28} />

          <Skeleton variant='text' width='90%' />
          <Skeleton variant='text' width='80%' />
          <Skeleton variant='text' width='65%' />
          <Skeleton variant='text' width='70%' />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Skeleton variant='text' width={140} height={28} />

          {[...Array(7)].map((_, index) => (
            <Skeleton key={index} variant='text' width={index % 2 === 0 ? "85%" : "70%"} />
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default ExtraInfoSkeleton;
